var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocPlaceholder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 364,
    height: 304,
    viewBox: "0 0 364 304",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_6867",
    x: 0,
    y: 0,
    width: 364,
    height: 304,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 8,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.02
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6774",
    "data-name": "Rectangle 6774",
    width: 37,
    height: 46,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16105",
    "data-name": "Group 16105",
    transform: "translate(-226 -154)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 226, 154)",
    filter: "url(#Rectangle_6867)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_6867-2",
    "data-name": "Rectangle 6867",
    d: "M6,0H178a6,6,0,0,1,6,6V124a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V6A6,6,0,0,1,6,0Z",
    transform: "translate(90 82)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6873",
    "data-name": "Rectangle 6873",
    width: 50,
    height: 6,
    transform: "translate(332 252)",
    fill: "#f3f3f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6874",
    "data-name": "Rectangle 6874",
    width: 127,
    height: 6,
    transform: "translate(332 266)",
    fill: "#f3f3f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6877",
    "data-name": "Rectangle 6877",
    width: 52,
    height: 6,
    transform: "translate(332 294)",
    fill: "#f3f3f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6879",
    "data-name": "Rectangle 6879",
    width: 85,
    height: 6,
    transform: "translate(332 336)",
    fill: "#f3f3f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6878",
    "data-name": "Rectangle 6878",
    width: 31,
    height: 6,
    transform: "translate(332 322)",
    fill: "#f3f3f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6875",
    "data-name": "Rectangle 6875",
    width: 48,
    height: 6,
    transform: "translate(332 280)",
    fill: "#f3f3f8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6876",
    "data-name": "Rectangle 6876",
    width: 52,
    height: 6,
    transform: "translate(332 308)",
    fill: "#f3f3f8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6",
    "data-name": "Mask Group 6",
    transform: "translate(390 277)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pdf-file",
    transform: "translate(0.433)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5580",
    "data-name": "Path 5580",
    d: "M42.593,2.269V37.006H5.8V9.783L15.49,0H40.416A2.261,2.261,0,0,1,42.593,2.269Z",
    transform: "translate(-5.729)",
    fill: "#eff2f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5581",
    "data-name": "Path 5581",
    d: "M13.556,9.783H5.9L15.612,0l-.071,7.656A1.975,1.975,0,0,1,13.556,9.783Z",
    transform: "translate(-5.758)",
    fill: "#dadede"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5582",
    "data-name": "Path 5582",
    d: "M27.748,23.141a28.236,28.236,0,0,1-3.511-4.254c.562-.851,1.9-5.742-.14-7.16s-3.09,1.205-3.09,1.205a8.022,8.022,0,0,0,1.264,6.239L19.814,24.63c-.281,0-8.075,3.048-5.407,6.806,2.738,3.757,6.53-5.317,6.53-5.317a55.918,55.918,0,0,1,5.968-1.134,9.386,9.386,0,0,0,3.862,3.19c3.23.851,3.581-1.843,3.581-1.843C34.419,22.787,27.748,23.141,27.748,23.141ZM15.741,30.159a.069.069,0,0,1-.07-.071c-.421-.992,2.809-2.907,2.809-2.907S16.724,30.585,15.741,30.159ZM23.044,13c.913.851.14,3.757.14,3.757S22.131,13.854,23.044,13ZM22.2,23.992l1.264-3.119,1.966,2.41ZM32.593,26.26h0c-.562.922-2.879-1.063-3.09-1.276h0c.351,0,3.37.213,3.09,1.276Zm9.971,11.768v8.365a2.274,2.274,0,0,1-2.247,2.269H7.947A2.273,2.273,0,0,1,5.7,46.394V38.028Z",
    transform: "translate(-5.7 -3.291)",
    fill: "#f2786b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5583",
    "data-name": "Path 5583",
    d: "M26.386,53.531a1.815,1.815,0,0,1-.567,1.347,2.634,2.634,0,0,1-1.631.425h-.567v2.056H22.7V51.9h1.631a2.409,2.409,0,0,1,1.56.425A1.375,1.375,0,0,1,26.386,53.531Zm-2.694,1.063h.5a1.878,1.878,0,0,0,.992-.213.915.915,0,0,0,.354-.78.822.822,0,0,0-.284-.709,1.609,1.609,0,0,0-.922-.213h-.638Zm8.294,0a2.616,2.616,0,0,1-.78,2.056,2.934,2.934,0,0,1-2.2.709H27.45V51.9h1.7a2.8,2.8,0,0,1,2.056.709A2.559,2.559,0,0,1,31.987,54.594Zm-.992,0c0-1.347-.638-1.985-1.843-1.985h-.78v3.97h.638C30.356,56.65,30.994,55.941,30.994,54.594Zm3.048,2.765h-.922V51.9H36.24v.78h-2.2v1.7H36.1v.78H34.043Z",
    transform: "translate(-10.829 -15.107)",
    fill: "#eff2f3"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocPlaceholder);
export default __webpack_public_path__ + "static/media/doc_placeholder.abe810e51562c7d1bc6e1de7fae9c81e.svg";
export { ForwardRef as ReactComponent };